import { Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./i18n/I18nProvider";
import { ThemeProvider, useTheme } from "./theme/ThemeProvider";
import { AuthProvider, useAuth } from "./auth/AuthProvider";
import { LoginPage } from "./pages/LoginPage";
import { AppShell } from "./shell/AppShell";
import { StatsPage } from "./pages/StatsPage";
import { SettingsPage } from "./pages/SettingsPage";
import { KbPage } from "./pages/KbPage";
import { LeadsPage } from "./pages/LeadsPage";
import { ProductsPage } from "./pages/ProductsPage";
import { IntegrationPage } from "./pages/IntegrationPage";
import { PreviewPage } from "./pages/PreviewPage";

function SonnerToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme} richColors position="bottom-right" />;
}

function Router() {
  const { status } = useAuth();

  if (status === "checking") {
    return null;
  }

  if (status === "anonymous") {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<Navigate to="/stats" replace />} />
        <Route path="/stats" element={<StatsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/preview" element={<PreviewPage />} />
        <Route path="/kb" element={<KbPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/leads" element={<LeadsPage />} />
        <Route path="/integration" element={<IntegrationPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/stats" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <AuthProvider>
          <div id="app">
            <Router />
          </div>
          <SonnerToaster />
        </AuthProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}
